import { symbolAnalysisLogic } from './symbol_analysis.logic';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import type { ActivityPlugin } from '../../core/types/activity.types';
import {
  SymbolAnalysisHost,
  SymbolAnalysisProjector,
  SymbolAnalysisStudent,
} from '../eval-blocks/SymbolAnalysisViews';

export const symbolAnalysisPlugin: ActivityPlugin<'symbol_analysis'> = {
  ...symbolAnalysisLogic,
  displayName: GAME_MODE_CATALOG.symbol_analysis.displayName,
  icon: GAME_MODE_CATALOG.symbol_analysis.icon,
  HostView: SymbolAnalysisHost,
  StudentView: SymbolAnalysisStudent,
  ProjectorView: SymbolAnalysisProjector,
};

export { demoSymbolAnalysisPayload } from './symbol_analysis.logic';
